import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { FMessage } from '../../hoc/IntlComponents';
import { number } from 'prop-types';
import Card from '../../components/Card/Card';

import { STATIC_PATH } from '../../config';
import { getStoreUrl } from '../../utils/utils';
import { getContestUrl } from '../../utils/utils';
import Icon from '../../components/Icon/Icon';
import Hint from '../../components/Hint/Hint';

const propTypes = {
  coins: number.isRequired,
  tickets: number.isRequired,
  position: number,
};

const defaultProps = {
  coins: 0,
  position: null,
};

const StoreWidget = ({ coins, collapsing, localStorageName }) => {
  // const getIcon = arrowDirection => (
  //   <Icon className="contest-icon" type={`arrow-${arrowDirection}`} />
  // );

  // const isInContest = () => master.slave || (master.master && master.master.approved);

  // const getFormattedPosition = (arrowDirection, difference) => {
  //   if (arrowDirection !== 0) {
  //     return (
  //       <small>
  //         {getIcon(arrowDirection)}
  //         {difference}
  //       </small>
  //     );
  //   }
  // };

  // const getPosition = () => {
  //   if (contest && contest.marathon && contest.marathon.position) {
  //     return (
  //       <span>
  //         {getFormattedPosition(contest.marathon.arrowDirection, contest.marathon.difference)}{' '}
  //         {contest.marathon.position}
  //       </span>
  //     );
  //   } else return 'No rate';
  // };

  return (
    <Card className="hideElement store-widget" localStorageName={localStorageName} collapsing={collapsing}>
      <Card.Header>
        <FormattedMessage id="widgets.store.title" defaultMessage="Prizes showcase" />
      </Card.Header>
      <Card.Body className="no-padding">
        <div className="coins-panel">
          <span className="coins-balance no-margin">
            <FMessage id="widgets.coins.balance" />
            <span className="coins-balance-value">
              <b>
                <img src={`${STATIC_PATH}/img/coin-big.svg`} alt="coin" /> {coins}
              </b>
            </span>
          </span>
          {/* {isInContest() && (
            <span className="coins-balance">
              <span>
                <FMessage id="contest.position" />
                <Hint id="contest-position-text">
                  <FMessage id="contest.hint" />
                </Hint>
              </span>
              <span className="coins-balance-value">
                <b>{getPosition()}</b>
              </span>
            </span>
          )} */}
        </div>
      </Card.Body>
      <Card.Footer className="no-padding">
        <div className="coins-link">
          <a
            role="button"
            className="btn btn-outline-primary btn-block no-focus"
            href={getStoreUrl()}
            target="_blank"
          >
            <FMessage id="widgets.coins.btn" />
          </a>
          {/* <a
            role="button"
            className="btn btn-primary no-focus btn-md contest"
            href="https://promo.offerrum.com"
            target="_blank"
          >
            <FMessage id="widgets.tickets.btn" />
          </a> */}
        </div>
      </Card.Footer>
    </Card>
  );
};

StoreWidget.propTypes = propTypes;
StoreWidget.defaultProps = defaultProps;

const mapStateToProps = state => ({
  coins: state.webmaster.profile.store.coins,
  // position: state.webmaster.profile.contest.position,
  // master: state.webmaster.profile.master,
  // contest: state.webmaster.profile.contest,
});

export default connect(mapStateToProps)(StoreWidget);
